"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroSimple() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="hero-simple" ref={ref} className="relative min-h-screen w-full overflow-hidden bg-background">
      {}
      <div className="absolute inset-0">
        <div className={`h-full w-full bg-cover bg-center transition-transform duration-[5000ms] ease-out ${isVisible ? "scale-105" : "scale-100"} bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1548683/img/hero_architectural_silk_texture.png)]`} />
        {}
        <div className="absolute inset-0 bg-white/90" />
      </div>

      {}
      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-6 text-center">
        {}
        <h1 className={`font-display text-6xl font-normal tracking-tight text-foreground transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] md:text-7xl lg:text-8xl ${isVisible ? "translate-y-0 opacity-100 [letter-spacing:0.05em]" : "translate-y-5 opacity-0 [letter-spacing:0em]"}`}>
          Nuestra Historia
        </h1>

        {}
        <div className={`mt-12 h-20 w-px bg-accent transition-all delay-300 duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} />
      </div>
    </section>;
}